"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _lodash = _interopRequireDefault(require("lodash"));
var IrcdDiffs = _interopRequireWildcard(require("@/helpers/IrcdDiffs"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _AutoComplete = _interopRequireDefault(require("./AutoComplete"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getInviteListSorter = extban => {
  if (!extban) {
    return (a, b) => Misc.strCompare(a.invited, b.invited);
  }
  const extbanColon = extban + ':';
  return (a, b) => {
    const aAccount = a.invited.indexOf(extbanColon) === 0;
    const bAccount = b.invited.indexOf(extbanColon) === 0;
    if (aAccount && !bAccount) {
      return -1;
    } else if (!aAccount && bAccount) {
      return 1;
    }
    return Misc.strCompare(a.invited, b.invited);
  };
};
var _default = exports.default = {
  components: {
    AutoComplete: _AutoComplete.default
  },
  props: ['buffer'],
  data() {
    return {
      inviteMaskOrAccount: '',
      inviteList: [],
      is_refreshing: false,
      clickUpdateTimeout: 0
    };
  },
  computed: {
    supportsAccounts() {
      return !!this.extban;
    },
    extban() {
      return IrcdDiffs.extbanAccount(this.buffer.getNetwork());
    },
    channelIsInviteOnly() {
      return typeof this.buffer.modes.i !== 'undefined';
    },
    areWeAnOp() {
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    sortedInviteList() {
      const sorter = getInviteListSorter(this.extban);
      return this.inviteList.slice().sort(sorter);
    },
    inviteListAccounts() {
      const extbanColon = this.extban + ':';
      return this.supportsAccounts ? this.inviteList.filter(i => i.invited.indexOf(extbanColon) === 0) : [];
    },
    anyRegisteredUserCanJoin() {
      if (!this.supportsAccounts) {
        return false;
      }
      if (!this.channelIsInviteOnly) {
        return false;
      }
      const extbanColon = this.extban + ':';

      // Find any invite that only consists of the extban and nothing else. Eg. '~a:'
      return this.inviteListAccounts.some(i => i.invited === extbanColon);
    },
    knownAccounts() {
      // Get an array of every account name we're aware of on the network, excluding
      // the ones we already have in our invite list
      const extbanColon = this.extban + ':';
      const accountMapper = invite => invite.invited.replace(extbanColon, '');
      const existingInviteAccounts = this.inviteListAccounts.map(accountMapper);
      const users = this.buffer.getNetwork().users;
      const accountUsers = [];
      Object.values(users).forEach(user => {
        if (user.account && !(0, _includes.default)(existingInviteAccounts).call(existingInviteAccounts, user.account)) {
          accountUsers.push(user);
        }
      });
      const autocompleteMapper = user => {
        let text = user.account;
        if (user.account !== user.nick) {
          text += ` (${user.nick})`;
        }
        return {
          text,
          user
        };
      };
      return _lodash.default.orderBy(accountUsers, ['account', 'nick']).map(autocompleteMapper);
    }
  },
  watch: {
    buffer() {
      this.inviteList = [];
      this.is_refreshing = false;
      this.clickUpdateTimeout = 0;
      this.updateInvitelist();
    }
  },
  created() {
    this.listen(this.$state, 'irc.mode', (event, network) => {
      if (network !== this.buffer.getNetwork()) {
        return;
      }
      if (!network.ircClient.caseCompare(event.target, this.buffer.name)) {
        return;
      }
      event.modes.forEach(change => {
        if (change.mode.length !== 2 || change.mode[1] !== 'I') {
          return;
        }
        if (change.mode[0] === '+') {
          this.inviteList.push({
            invited: change.param,
            invited_at: Math.floor(event.time / 1000),
            invited_by: event.nick,
            channel: event.target
          });
        } else if (change.mode[0] === '-') {
          this.inviteList = this.inviteList.filter(invite => invite.invited !== change.param);
        }
      });
    });
    this.updateInvitelist();
  },
  methods: {
    displayMask(inviteMask) {
      return inviteMask.replace(this.extban + ':', '') || this.$t('invite_any_registered');
    },
    clickUpdateInvitelist() {
      if (this.clickUpdateTimeout) {
        return;
      }
      this.clickUpdateTimeout = setTimeout(() => {
        this.clickUpdateTimeout = 0;
      }, 4000);
      this.updateInvitelist();
    },
    updateInvitelist() {
      if (this.is_refreshing || this.buffer.getNetwork().state !== 'connected') {
        return;
      }
      const channelName = this.buffer.name;
      const network = this.buffer.getNetwork();
      this.is_refreshing = true;
      this.buffer.getNetwork().ircClient.inviteList(channelName, event => {
        const currentNetwork = this.buffer.getNetwork();
        const bufferMatches = currentNetwork.ircClient.caseCompare(this.buffer.name, event.channel);
        if (!bufferMatches || network !== currentNetwork) {
          // The buffer or network changed since making the request
          return;
        }
        this.inviteList = event ? event.invites : [];
        this.is_refreshing = false;
      });
    },
    addInvite() {
      const maskOrAccount = this.inviteMaskOrAccount.trim();
      if (!maskOrAccount) {
        return;
      }
      const ircClient = this.buffer.getNetwork().ircClient;
      const isMask = (0, _includes.default)(maskOrAccount).call(maskOrAccount, '@') || (0, _includes.default)(maskOrAccount).call(maskOrAccount, ':');
      if (this.supportsAccounts && !isMask) {
        ircClient.addInvite(this.buffer.name, `${this.extban}:${maskOrAccount}`);
      } else {
        ircClient.addInvite(this.buffer.name, maskOrAccount);
      }
      this.inviteMaskOrAccount = '';
    },
    removeInvite(mask) {
      const channelName = this.buffer.name;
      this.buffer.getNetwork().ircClient.removeInvite(channelName, mask);
    },
    setInviteOnly() {
      this.buffer.getNetwork().ircClient.mode(this.buffer.name, '+i');
    },
    removeInviteOnly() {
      this.buffer.getNetwork().ircClient.mode(this.buffer.name, '-i');
    },
    accountSelected(_value, item) {
      this.inviteMaskOrAccount = item.user.account;
    },
    inviteKeyDown(event) {
      if (!this.$refs.autocomplete) {
        return;
      }
      const autoComplete = this.$refs.autocomplete;
      if (event.key === 'Tab') {
        event.preventDefault();
        autoComplete.selectCurrentItem();
        return;
      }
      const selectedItem = autoComplete.selectedItem;
      if (event.key === 'Enter' && selectedItem.user.account === this.inviteMaskOrAccount) {
        event.preventDefault();
        this.addInvite();
        return;
      }
      this.$refs.autocomplete.handleOnKeyDown(event);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelInvitelist"]
window._kiwi_exports.components.ChannelInvitelist = exports.default ? exports.default : exports;
